<template>
    <div>我是子页面1</div>
</template>

<script>
    export default {}
</script>

<style lang="less">
</style>